import { Guid } from '@web/utils';

export class WarehouseSkuUsageReceipt {
  public constructor(
    private readonly data: {
      id: Guid;
      number: string;
    },
  ) {}

  public get id(): string {
    return this.data.id;
  }

  public get number(): string {
    return this.data.number;
  }
}
